import { Box, Typography } from '@mui/material';
import img1 from './img/companyLogo1.png';
import img2 from './img/companyLogo2.png';
import img3 from './img/companyLogo3.png';
import img4 from './img/companyLogo4.png';
import img5 from './img/companyLogo5.png';
import img6 from './img/companyLogo6.png';
import img7 from './img/companyLogo7.png';
import img8 from './img/companyLogo8.png';
import img9 from './img/companyLogo9.png';
import img10 from './img/companyLogo10.png';
import img11 from './img/companyLogo11.png';
import img12 from './img/companyLogo12.png';
import img13 from './img/companyLogo13.png';
import img14 from './img/companyLogo14.png';
import img15 from './img/companyLogo15.png';
import img16 from './img/companyLogo16.png';
import img17 from './img/companyLogo17.png';
import img18 from './img/companyLogo18.png';
import img19 from './img/companyLogo19.png';
import img20 from './img/companyLogo20.png';
import img21 from './img/companyLogo21.png';

const logos = [
    { name: 'Digio', src: img1 },
    { name: 'Fortune', src: img2 },
    { name: 'TataMoters', src: img3 },
    { name: 'Vivo', src: img4 },
    { name: 'Scullcandy', src: img5 },
    { name: 'GrowthX', src: img6 },
    { name: 'DelhiTransportCorprate', src: img7 },
    { name: 'EatFit', src: img8 },
    { name: 'Shine', src: img9 },
    { name: 'BombaySaving', src: img10 },
    { name: 'Quikar', src: img11 },
    { name: 'Yulu', src: img12 },
    { name: 'Peoplematters', src: img13 },
    { name: 'IndianExpress', src: img14 },
    { name: 'iskon', src: img15 },
    { name: 'StayVista', src: img16 },
    { name: 'Yulu', src: img17 },
    { name: 'JaroEducation', src: img18 },
    { name: 'Sobha', src: img19 },
    { name: 'Sourya', src: img20 },
    { name: 'AngelOne', src: img21 },
];


const CompanySection = () => {

    const logoList = [...logos, ...logos]; // For smooth infinite scroll

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
                sx={{
                    backgroundColor: '#fff',
                    textAlign: 'center',
                    pt: '4rem',
                    pb: '4rem',
                    width: '100%',
                    maxWidth: '1400px',
                    px: { xs: '1rem', sm: '2rem', md: '3rem' },
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '2.2rem', md: '3.5rem' },
                        lineHeight: 1.1,
                    }}
                >
                    Founders & Marketers Love Us
                </Typography>

                <Typography
                    sx={{
                        fontSize: { xs: '1rem', md: '1.5rem' },
                        color: '#666',
                        mt: '1rem',
                        mb: '2.5rem',
                    }}
                >
                    Trusted by 100,000+ Businesses across 57 Countries
                </Typography>

                <Box
                    sx={{
                        overflow: 'hidden',
                        position: 'relative',
                        maskImage:
                            'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            width: 'max-content',
                            animation: 'scroll 25s linear infinite',
                            '&:hover': {
                                animationPlayState: 'paused',
                            },
                            '@keyframes scroll': {
                                '0%': { transform: 'translateX(0)' },
                                '100%': { transform: 'translateX(-50%)' },
                            },
                        }}
                    >
                        {logoList.map((logo, index) => (
                            <Box
                                key={`${logo.name}-${index}`}
                                sx={{
                                    mx: { xs: 2, sm: 3, md: 4 },
                                    flex: '0 0 auto',
                                    width: { xs: 80, sm: 100, md: 120 },
                                    height: { xs: 40, sm: 50, md: 60 },
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img
                                    src={logo.src}
                                    alt={logo.name}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default CompanySection;